<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 23.5L19.5 23.5C20.6 23.5 21.5 22.6 21.5 21.5L21.5 7.5L19.5 7.5L19.5 21.5L7.5 21.5L7.5 23.5ZM4.5 19.5L15.5 19.5C16.6 19.5 17.5 18.6 17.5 17.5L17.5 3.5C17.5 2.4 16.6 1.5 15.5 1.5L4.5 1.5C3.4 1.5 2.5 2.4 2.5 3.5L2.5 17.5C2.5 18.6 3.4 19.5 4.5 19.5ZM4.5 3.5L15.5 3.5L15.5 17.5L4.5 17.5L4.5 3.5Z"
      :fill="props.color"
    />
  </svg>
</template>
<script lang="ts" setup>
  const props = defineProps({
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#fff',
    },
  })
</script>
